import React, { useState } from 'react';
import UserSettingsMenu from '../settings/UserSettingsMenu';
import BackgroundPicker from '../BackgroundPicker';
import { useAuth } from '../../contexts/AuthContext';
import { updateUserSettings } from '../../utils/firebaseUtils';

const UserProfileMenu = ({ onBackgroundChange }) => { // onBackgroundChange is for the main dashboard
    const [activeSection, setActiveSection] = useState(null);
    const { user } = useAuth();

    const handleSectionChange = (section) => {
        setActiveSection(section);
    };

    // This function now handles selecting a background for either dashboard or Ideas Plan
    const handleSelectBackground = async (image, type) => {
        if (!user) return;

        let settingsUpdate = {};
        if (type === 'dashboard') {
            settingsUpdate = { background: image.urls.full };
            // Call the original prop for dashboard background to update Navbar/Dashboard state if necessary
            if (onBackgroundChange) {
                onBackgroundChange(image); // Pass the full image object or just URL as needed by parent
            }
        } else if (type === 'ideasPlan') {
            settingsUpdate = { ideasPlanBackground: image.urls.full };
        }

        if (Object.keys(settingsUpdate).length > 0) {
            await updateUserSettings(user.uid, settingsUpdate);
        }
        setActiveSection(null); // Go back to the main settings menu
    };

    switch (activeSection) {
        case 'background': // For Dashboard Background
            return (
                <BackgroundPicker
                    onSelectBackground={(image) => handleSelectBackground(image, 'dashboard')}
                    projectTitle="Dashboard" // Optional: to give context to Unsplash search
                />
            );
        case 'ideasPlanBackground': // For Ideas Plan Background
            return (
                <BackgroundPicker
                    onSelectBackground={(image) => handleSelectBackground(image, 'ideasPlan')}
                    projectTitle="Ideas Plan" // Optional: to give context to Unsplash search
                />
            );
        default: // Show UserSettingsMenu
            return (
                <UserSettingsMenu
                    onSectionChange={handleSectionChange} // This will set activeSection
                />
            );
    }
};

export default UserProfileMenu;
